import { defineMessages } from 'react-intl';

export default defineMessages({
    businessAutoQuote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.ba.Auto Insurance Quote',
        defaultMessage: 'Auto Insurance Quote'
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.ba.Location',
        defaultMessage: 'Location'
    },
    vehicles: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.ba.Vehicles',
        defaultMessage: 'Vehicles'
    },
    drivers: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.ba.Drivers',
        defaultMessage: 'Drivers'
    }
});
